import type { FC, MouseEvent } from 'react';
import { SettingModalCommon, SettingProvider } from '../common';
import { Option } from '../option';
import { useOpenModal } from '@flowus/common/next-modal';
import { ListItemType, ListView } from 'src/common/components/list-view';
import { listViewNormalClassName } from 'src/common/components/list-view/helper';
import { keys } from 'lodash-es';
import { ShowInLinePageIconType } from '@next-space/fe-api-idl';
import { useModel } from '@flowus/common/create-model';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';

export const PageIconSetting: FC = () => {
  const { t } = useAppTranslation();
  const openModal = useOpenModal();
  const { spaceSettingState } = useModel(SettingProvider);
  const { inlinePageIcon, setInlinePageIcon } = spaceSettingState;

  const OptionText = {
    [ShowInLinePageIconType.SHOW_ALL]: t(
      'components.setting_modal.space_setting.page_icon.show_all'
    ),
    [ShowInLinePageIconType.SHOW_CUSTOM]: t(
      'components.setting_modal.space_setting.page_icon.show_custom'
    ),
    [ShowInLinePageIconType.HIDE]: t('components.setting_modal.space_setting.page_icon.hide'),
  };

  const handleClick = (event: MouseEvent) => {
    openModal.dropdown({
      popcorn: event.currentTarget,
      content: (_) => (
        <ListView
          className={listViewNormalClassName}
          items={keys(OptionText).map((key) => ({
            type: ListItemType.OPERABLE_BLOCK_TEXT,
            data: {
              key,
              selected: key === inlinePageIcon,
              title: OptionText[key as ShowInLinePageIconType],
            },
          }))}
          onItemClick={(item) => {
            setInlinePageIcon(item.data.key);
            _.onCloseModal();
          }}
        />
      ),
    });
  };

  return (
    <Option
      title={t('components.setting_modal.space_setting.page_icon.title')}
      description={t('components.setting_modal.space_setting.page_icon.description')}
      rightPart={
        <SettingModalCommon.DropdownButton
          onClick={handleClick}
          content={OptionText[inlinePageIcon]}
        />
      }
    />
  );
};
